export default __webpack_public_path__ + "static/media/160x90.4de013e8.jpg";